import { render, staticRenderFns } from "./PolicyHolderCancelSignature.vue?vue&type=template&id=7c69874b&"
import script from "./PolicyHolderCancelSignature.vue?vue&type=script&lang=js&"
export * from "./PolicyHolderCancelSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports